'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var classes = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classes__default = /*#__PURE__*/_interopDefaultLegacy(classes);

var Label = function (_a) {
    var className = _a.className, rest = _tslib.__rest(_a, ["className"]);
    return (jsxRuntime.jsx("label", _tslib.__assign({ className: classes__default["default"](className) }, rest)));
};

exports["default"] = Label;
//# sourceMappingURL=Label.js.map
